{
  "match-requests-status-messages": {
    "nl": {
      "success": {
        "update-match-request": "Hulpvraag is aangepast"
      },
      "error": {
        "match-request": "Ophalen van de hulpvraag is mislukt",
        "match-requests": "Ophalen van de hulpvragen is mislukt",
        "fetch-match-request": "Hulpvraag ophalen is mislukt",
        "update-match-request": "Updaten van de hulpvraag is mislukt"
      }
    },
    "en": {
      "success": {
        "update-match-request": "Request has been updated"
      },
      "error": {
        "match-request": "Fetching the match request has failed",
        "match-requests": "Fetching the match requests has failed",
        "fetch-match-request": "Fetching the request has failed",
        "update-match-request": "Updating the request has failed"
      }
    }
  },
  "bug-status-messages": {
    "nl": {
      "success": {
        "create-bug": "Bug is aangemaakt"
      },
      "error": {
        "create-bug": "Fout bij aanmaken bug"
      }
    },
    "en": {
      "success": {
        "create-bug": "Bug has been created"
      },
      "error": {
        "create-bug": "Creating the bug has failed"
      }
    }
  },
  "survey-status-messages": {
    "nl": {
      "rating": "Het getal moet tussen ${min} en ${max} liggen"
    },
    "en": {
      "rating": "Enter a number between ${min} and ${max}"
    }
  },
  "user-status-messages": {
    "nl": {
      "success": {
        "update-user": "Gegevens zijn aangepast",
        "update-contact-details": "Gegevens zijn bijgewerkt. Je account is nu weer actief.",
        "update-cook": "Gegevens zijn aangepast",
        "update-foodie": "Gegevens zijn aangepast",
        "update-caretaker": "Gegevens zijn aangepast",
        "update-meal": "Maaltijd is aangepast",
        "create-meal": "Maaltijd is aangemaakt",
        "cancel-meal": "Maaltijd is geannuleerd",
        "upload-vog": "VOG is opgeslagen"
      },
      "error": {
        "fetch-user": "Ophalen profiel is mislukt",
        "fetch-cook": "Ophalen profiel is mislukt",
        "fetch-foodie": "Ophalen profiel is mislukt",
        "fetch-caretaker": "Ophalen profiel is mislukt",
        "fetch-match-meals": "Ophalen maaltijden is mislukt",
        "fetch-matches": "Ophalen matches is mislukt",
        "create-match-meals": "Maaltijden aanmaken is mislukt",
        "fetch-missing-cook-details": "Ophalen van de ontbrekende gegevens is mislukt",
        "update-user": "Aanpassen profiel is mislukt",
        "update-contact-details": "Er ging iets mis bij het activeren van je account. Probeer het opnieuw.",
        "update-cook": "Aanpassen profiel is mislukt",
        "update-cook-unavailability": "Aanpassen beschikbaarheid is mislukt",
        "update-foodie": "Aanpassen is mislukt",
        "update-caretaker": "Aanpassen is mislukt",
        "update-meal": "Maaltijd aanpassen is mislukt",
        "cancel-meal": "Maaltijd annuleren is mislukt",
        "create-meal": "Maaltijd aanmaken is mislukt",
        "upload-vog": "Opslaan van de VOG is mislukt",
        "update-survey": "Opslaan van de vragenlijst is mislukt",
        "update-meal-wishes-failed": "Opslaan dieetvoorkeuren is mislukt",
        "thinkific-signup-account-exists": "Koppelen van accounts is mislukt, bel de helpdesk",
        "thinkific-signup-account-failed": "Thinkific Account aanmaken mislukt",
        "fetch-wallets": "Ophalen saldo mutaties is mislukt"
      }
    },
    "en": {
      "success": {
        "update-user": "Profile has been updated",
        "update-contact-details": "Your information has been updated. Your account is now active again.",
        "update-cook": "Profile has been updated",
        "update-foodie": "Profile has been updated",
        "update-caretaker": "Profile has been updated",
        "update-meal": "Meal has been updated",
        "create-meal": "Meal has been created",
        "cancel-meal": "Meal has been canceled",
        "upload-vog": "VOG has been uploaded"
      },
      "error": {
        "fetch-user": "Fetching profile has failed",
        "fetch-cook": "Fetching profile has failed",
        "fetch-foodie": "Fetching profile has failed",
        "fetch-caretaker": "Fetching profile has failed",
        "fetch-match-meals": "Fetching meals has failed",
        "fetch-matches": "Fetching matches has failed",
        "create-match-meals": "Creating meals has failed",
        "fetch-missing-cook-details": "Fetching profile has failed",
        "update-user": "Updating profile has failed",
        "update-contact-details": "Something went wrong while activating your account. Please try again.",
        "update-cook": "Fetching profile has failed",
        "update-cook-unavailability": "Updating availability failed",
        "update-foodie": "Fetching profile has failed",
        "update-caretaker": "Fetching profile has failed",
        "update-meal": "Updating meal has failed",
        "cancel-meal": "Canceling meal has failed",
        "create-meal": "Creating meal has failed",
        "upload-vog": "Uploading VOG has failed",
        "update-survey": "Storing answers has failed",
        "update-meal-wishes-failed": "Updating meal wishes has failed",
        "thinkific-signup-account-exists": "Connecting the accounts has failed, please call the helpdesk",
        "thinkific-signup-account-failed": "Creating Thinkific account has failed",
        "fetch-wallets": "Fetching balance mutations has failed"
      }
    }
  },
  "auth-status-messages": {
    "nl": {
      "success": {
        "request-password-reset": "Email is verstuurd voor het herstellen van het wachtwoord",
        "reset-password": "Jouw wachtwoord is gewijzigd, je kan nu inloggen",
        "change-password": "Wachtwoord is gewijzigd",
        "send-new-verification-email": "Nieuwe email is verstuurd"
      },
      "error": {
        "login": "Inloggen is mislukt",
        "request-password-reset": "Wachtwoord herstellen mail aanvragen is mislukt. Probeer het later nog eens.",
        "reset-password": "Wachtwoord wijzigen is niet gelukt, neem contact op.",
        "change-password": {
          "correct_password": "Wijzigen van het wachtwoord is mislukt. Probeer het later nog eens.",
          "incorrect_password": "Dat oude wachtwoord klopt niet. Vul het juiste wachtwoord in om het weer te proberen."
        },
        "send-new-verification-email": "Nieuwe email versturen is mislukt. Probeer het later nog eens.",
        "verify-email": "Verificatie van de email is mislukt"
      }
    },
    "en": {
      "success": {
        "request-password-reset": "Email has been sent for resetting the password",
        "reset-password": "Your password has been changed, you are now able to login",
        "change-password": "Password has been changed",
        "send-new-verification-email": "New email has been sent"
      },
      "error": {
        "login": "Logging in has failed",
        "request-password-reset": "Requesting a password reset has failed. Please try again later.",
        "reset-password": "Unable to change your password, please contact us.",
        "change-password": {
          "correct_password": "Changing the password has failed. Please try again later.",
          "incorrect_password": "That old password is incorrect. Please enter the correct password to try again."
        },
        "send-new-verification-email": "Sending a new email has failed. Please try again later.",
        "verify-email": "Verification of the email has failed"
      }
    }
  },
  "registration-status-messages": {
    "nl": {
      "success": {
        "register-match-request": "Hulpvraag is ingediend"
      },
      "error": {
        "register-cook": "Aanmelden is mislukt",
        "register-foodie": "Aanmelden is mislukt",
        "register-match-request": "Indienen van de hulpvraag is mislukt",
        "register-collector": "Aanmelden is mislukt"
      }
    },
    "en": {
      "success": {
        "register-match-request": "Request has been submitted"
      },
      "error": {
        "register-cook": "Signing up has failed",
        "register-foodie": "Signing up has failed",
        "register-match-request": "Submitting the request has failed",
        "register-collector": "Signing up has failed"
      }
    }
  },
  "recurring-donation-status-messages": {
    "nl": {
      "success": {
        "cancel": "Periodieke donatie is stopgezet"
      },
      "error": {
        "get-recurring": "Periodieke donaties ophalen mislukt",
        "cancel": "Periodieke donatie stopzetten mislukt"
      }
    },
    "en": {
      "success": {
        "cancel": "Recurring donation has been cancelled"
      },
      "error": {
        "get-recurring": "Fetching recurring donations failed",
        "cancel": "Cancelling Recurring donation failed"
      }
    }
  },
  "collection-boxes-status-messages": {
    "nl": {
      "error": {
        "fetch": "Ophalen actiepagina's mislukt"
      }
    },
    "en": {
      "error": {
        "fetch": "Fetching fundraiser pages has failed"
      }
    }
  },
  "open-vacancy-status-messages": {
    "nl": {
      "success": {
        "vacancy": "Bedankt voor je sollicitatie! We nemen per mail contact met je op.",
        "ambassador": "Bedankt voor je aanmelding als ambassadeur! We nemen per mail contact met je op."
      },
      "error": {
        "contact": "Er is iets misgegaan. Probeer het later opnieuw"
      }
    },
    "en": {
      "success": {
        "vacancy": "Thank you for your application! We will contact you by email.",
        "ambassador": "Thank you for registering as an ambassador! We will contact you by email."
      },
      "error": {
        "contact": "Something went wrong. Please try again later."
      }
    }
  }
}
